import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-2">
          焦点专题
        </h2>
        <p className="text-sm text-foreground-500 mb-8">深度追踪当前最热门事件</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {carouselData.map((item) => (
            <article
              key={item.id}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-200 transition-all duration-300 group cursor-pointer"
            >
              <div className="relative overflow-hidden h-[220px]">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  width="1200"
                  height="700"
                />
                <span className="absolute top-3 left-3 px-2 py-0.5 text-xs font-semibold bg-accent-500 text-background-50 rounded whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-950 font-heading mb-2 line-clamp-2 leading-snug group-hover:text-accent-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {item.summary}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.reads}阅读
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-1-line"></i>
                    {item.commentCount}评论
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}